import { render } from "./Terms1View.vue?vue&type=template&id=54b4a9d8&scoped=true"
const script = {}

import "./Terms1View.vue?vue&type=style&index=0&id=54b4a9d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b4a9d8"]])

export default __exports__